import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import Controls from './controls/Controls'
import Notification from './Notification'
import { Form, useForm } from './useForm'
import { useDispatch, useSelector } from 'react-redux'
import {
  hrAssignExtensionAction,
  hrGetEmployeeByIdAction,
} from '../actions/hrActions'
import { HR_ASSIGN_EXTENSION_EMPLOYEE_RESET } from '../constants/hrConstants'

const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const initialValues = {
  extension: '',
}

const HRExtension = ({ setOpenExtPopup, extensions, id }) => {
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const classes = useStyles()
  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('extension' in fieldValues)
      temp.extension = fieldValues.extension ? '' : 'This field is required'
    setErrors({
      ...temp,
    })
    if (fieldValues === values) return Object.values(temp).every((x) => x == '')
  }

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValues, true, validate)

  const dispatch = useDispatch()

  const handleSubmit = (e) => {
    e.preventDefault()
    if (validate()) {
      dispatch(hrAssignExtensionAction(id, values.extension))
    }
  }

  const hrAssignExt = useSelector((state) => state.hrAssignExt)
  const { loading, error, assignExtensionInfoEmployee } = hrAssignExt

  useEffect(() => {
    dispatch({ type: HR_ASSIGN_EXTENSION_EMPLOYEE_RESET })
    if (assignExtensionInfoEmployee) {
      setNotify({
        isOpen: true,
        message: assignExtensionInfoEmployee.msg,
        type: 'success',
      })
      setTimeout(() => {
        setOpenExtPopup(false)
        dispatch(hrGetEmployeeByIdAction(id))
      }, 2000)
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        type: 'error',
      })
    }
  }, [assignExtensionInfoEmployee, error, dispatch, id])

  return (
    <>
      <Form autoComplete='off' onSubmit={handleSubmit}>
        <Controls.Select
          label='Extension *'
          name='extension'
          value={values.extension}
          onChange={handleInputChange}
          error={errors.extension}
          options={extensions}
        />
        <Controls.Button
          type='submit'
          fullWidth
          text='submit'
          className={classes.submit}
          loading={loading}
        />
      </Form>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  )
}

export default HRExtension
